import React, { useRef, useState } from 'react';

const PERIOD_DRIVE_LINKS = {
  'T2': 'https://drive.google.com/drive/folders/1ET40dKyOcQjKAfeQreEsZedig4J5Khl8?usp=sharing',
  'T3': 'https://drive.google.com/drive/folders/16rlpe058uJrIxXSjgkU17b2PcAPnhnMJ?usp=sharing'
};

export default function WorksheetRepository({ onBack }) {
  const periodSectionRef = useRef(null);
  const [highlightPeriods, setHighlightPeriods] = useState(false);

  // Desplazar suavemente a la sección de Carpetas Oficiales por Periodo (T2 y T3)
  const scrollToPeriods = () => {
    if (periodSectionRef.current) {
      periodSectionRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      window.scrollTo({ top: 120, behavior: 'smooth' });
    }
    setHighlightPeriods(true);
    setTimeout(() => setHighlightPeriods(false), 2500);
  };

  return (
    <div className="space-y-8 text-slate-100 animate-fadeIn">
      
      {/* ENCABEZADO PRINCIPAL */}
      <div className="bg-gradient-to-r from-blue-950 via-indigo-900 to-purple-950 border border-blue-500/40 p-6 md:p-8 rounded-3xl shadow-2xl backdrop-blur-xl">
        <div className="flex justify-between items-start flex-wrap gap-4">
          <div>
            <span className="inline-block bg-blue-500/20 text-blue-300 text-[10px] md:text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider mb-3 border border-blue-400/30">
              Acceso Abierto en Google Drive • IE Enrique Olaya Herrera
            </span>
            <h2 className="text-xl md:text-3xl font-black text-white flex items-center gap-2">
              📁 Repositorio Oficial de Guías y Talleres Pedagógicos
            </h2>
            <p className="text-slate-300 text-xs md:text-sm mt-2 leading-relaxed max-w-3xl">
              Descarga o consulta directamente desde Google Drive todos los archivos compartidos, guías de trabajo y talleres pedagógicos organizados por <strong>Periodos Académicos 2026</strong> (Periodo 2 y Periodo 3).
            </p>
          </div>
          {onBack && (
            <button
              onClick={onBack}
              className="bg-slate-800/90 hover:bg-slate-700 text-slate-200 border border-slate-600 px-4 py-2 rounded-xl text-xs font-bold transition flex items-center gap-1.5 cursor-pointer shadow-lg hover:text-white"
            >
              ← Volver
            </button>
          )}
        </div>
      </div>

      {/* SECCIÓN 1: CARPETAS ORGANIZADAS POR PERIODO 2026 (T2 Y T3) */}
      <div 
        ref={periodSectionRef}
        id="carpetas-periodos-oficiales"
        className={`space-y-4 transition-all duration-500 rounded-3xl p-3 md:p-4 ${
          highlightPeriods ? 'ring-4 ring-amber-400 bg-amber-950/20 shadow-2xl' : ''
        }`}
      >
        <div className="flex items-center gap-2 border-b border-slate-800 pb-2">
          <span className="text-2xl">🗓️</span>
          <div>
            <h3 className="text-base md:text-lg font-black text-white flex items-center gap-2 flex-wrap">
              <span>Carpetas Oficiales por Periodo — Año Lectivo 2026</span>
              <span className="text-xs bg-amber-500/20 text-amber-300 px-2.5 py-0.5 rounded-full border border-amber-500/40 font-mono">
                T2 y T3
              </span>
            </h3>
            <p className="text-xs text-slate-400">
              Carpetas compartidas generales con el material curricular, talleres imprimibles y actividades de cada periodo.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* CARPETA T2: T2_Inglés_2026 */}
          <div className="bg-gradient-to-b from-slate-900/95 to-slate-950 border-2 border-amber-500/50 hover:border-amber-400 p-6 rounded-3xl shadow-xl flex flex-col justify-between transition transform hover:scale-[1.01] space-y-4">
            <div>
              <div className="flex justify-between items-center mb-3">
                <span className="bg-amber-500/20 text-amber-300 font-mono font-extrabold text-xs px-3 py-1 rounded-xl border border-amber-400/40 uppercase tracking-wide flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-amber-400 animate-pulse"></span>
                  Periodo 2 (T2)
                </span>
                <span className="text-3xl">📂</span>
              </div>
              <h4 className="text-xl font-black text-white flex items-center gap-2">
                T2_Inglés_2026
              </h4>
              <span className="text-[11px] font-mono text-amber-300/80 block mt-0.5">
                Carpeta Drive: T2_English_2026
              </span>
              <p className="text-xs text-slate-300 mt-3 leading-relaxed">
                Repositorio con guías pedagógicas, talleres imprimibles en formato PDF, material de lectura y actividades correspondientes al <strong>Segundo Periodo (T2)</strong> para los grados 6°, 7° y 9°.
              </p>
            </div>

            <div className="pt-4 border-t border-slate-800 space-y-2">
              <a 
                href={PERIOD_DRIVE_LINKS['T2']}
                target="_blank" 
                rel="noopener noreferrer"
                className="w-full bg-gradient-to-r from-amber-600 via-amber-500 to-orange-600 hover:from-amber-500 hover:to-orange-500 text-slate-950 font-black py-3.5 rounded-2xl transition shadow-xl text-xs flex items-center justify-center gap-2 cursor-pointer transform hover:scale-[1.02]"
              >
                📁 Abrir Carpeta T2_Inglés_2026 en Drive ↗
              </a>
              <span className="text-[10px] text-slate-400 block text-center">Acceso compartido y público en Google Drive</span>
            </div>
          </div>

          {/* CARPETA T3: T3_Inglés_2026 */}
          <div className="bg-gradient-to-b from-slate-900/95 to-slate-950 border-2 border-emerald-500/50 hover:border-emerald-400 p-6 rounded-3xl shadow-xl flex flex-col justify-between transition transform hover:scale-[1.01] space-y-4">
            <div>
              <div className="flex justify-between items-center mb-3">
                <span className="bg-emerald-500/20 text-emerald-300 font-mono font-extrabold text-xs px-3 py-1 rounded-xl border border-emerald-400/40 uppercase tracking-wide flex items-center gap-1.5">
                  <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
                  Periodo 3 (T3)
                </span>
                <span className="text-3xl">📂</span>
              </div>
              <h4 className="text-xl font-black text-white flex items-center gap-2">
                T3_Inglés_2026
              </h4>
              <span className="text-[11px] font-mono text-emerald-300/80 block mt-0.5">
                Carpeta Drive: T3_English_2026
              </span>
              <p className="text-xs text-slate-300 mt-3 leading-relaxed">
                Repositorio con guías pedagógicas, talleres avanzados, proyectos de consolidación curricular y preparación para pruebas evaluativas del <strong>Tercer Periodo (T3)</strong>.
              </p>
            </div>

            <div className="pt-4 border-t border-slate-800 space-y-2">
              <a 
                href={PERIOD_DRIVE_LINKS['T3']}
                target="_blank" 
                rel="noopener noreferrer"
                className="w-full bg-gradient-to-r from-emerald-600 via-teal-500 to-emerald-600 hover:from-emerald-500 hover:to-teal-400 text-slate-950 font-black py-3.5 rounded-2xl transition shadow-xl text-xs flex items-center justify-center gap-2 cursor-pointer transform hover:scale-[1.02]"
              >
                📁 Abrir Carpeta T3_Inglés_2026 en Drive ↗
              </a>
              <span className="text-[10px] text-slate-400 block text-center">Acceso compartido y público en Google Drive</span>
            </div>
          </div>

        </div>
      </div>

      {/* SECCIÓN 2: CARPETAS TEMÁTICAS POR GRADO ACADÉMICO */}
      <div className="space-y-4 pt-2">
        <div className="flex items-center gap-2 border-b border-slate-800 pb-2">
          <span className="text-xl">📚</span>
          <div>
            <h3 className="text-base md:text-lg font-black text-white">
              Carpetas Temáticas por Grado Académico
            </h3>
            <p className="text-xs text-slate-400">
              Al hacer clic en cada grado, serás llevado a las carpetas oficiales por periodo donde verás el material de T2 y T3.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          
          {/* GRADO 6° */}
          <div className="bg-slate-900/90 border border-slate-700/80 p-6 rounded-3xl shadow-xl flex flex-col justify-between hover:border-blue-400 transition space-y-4">
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="bg-blue-600/30 text-blue-300 font-mono font-bold text-xs px-2.5 py-1 rounded-lg border border-blue-400/40">
                  Grado 6°
                </span>
                <span className="text-2xl">📘</span>
              </div>
              <h4 className="text-lg font-extrabold text-white">Fundamentos y Deletreo</h4>
              <p className="text-xs text-slate-300 mt-2 leading-relaxed">
                Guías de saludos, abecedario, datos personales, la familia, la casa, rutinas diarias y vocabulario básico.
              </p>
            </div>

            <div className="pt-4 border-t border-slate-800 space-y-2.5">
              <button 
                onClick={scrollToPeriods}
                className="w-full bg-blue-600 hover:bg-blue-500 text-white font-black py-3 rounded-xl transition shadow-lg text-xs flex items-center justify-center gap-2 cursor-pointer transform hover:scale-[1.02]"
              >
                📁 Ver Carpetas de Periodo (T2 y T3) ↑
              </button>
              
              <div className="flex items-center justify-center gap-2 pt-1 text-center">
                <a
                  href={PERIOD_DRIVE_LINKS['T2']}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[11px] font-bold text-amber-300 hover:text-amber-200 bg-amber-950/60 border border-amber-500/40 px-2.5 py-1 rounded-lg transition"
                >
                  Abrir T2 ↗
                </a>
                <a
                  href={PERIOD_DRIVE_LINKS['T3']}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[11px] font-bold text-emerald-300 hover:text-emerald-200 bg-emerald-950/60 border border-emerald-500/40 px-2.5 py-1 rounded-lg transition"
                >
                  Abrir T3 ↗
                </a>
              </div>
            </div>
          </div>

          {/* GRADO 7° */}
          <div className="bg-slate-900/90 border border-slate-700/80 p-6 rounded-3xl shadow-xl flex flex-col justify-between hover:border-indigo-400 transition space-y-4">
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="bg-indigo-600/30 text-indigo-300 font-mono font-bold text-xs px-2.5 py-1 rounded-lg border border-indigo-400/40">
                  Grado 7°
                </span>
                <span className="text-2xl">📗</span>
              </div>
              <h4 className="text-lg font-extrabold text-white">Task-Based Learning</h4>
              <p className="text-xs text-slate-300 mt-2 leading-relaxed">
                Talleres de emociones, tiempo libre, lugares de la ciudad, sustantivos contables e incontables y Pasado Simple.
              </p>
            </div>

            <div className="pt-4 border-t border-slate-800 space-y-2.5">
              <button 
                onClick={scrollToPeriods}
                className="w-full bg-indigo-600 hover:bg-indigo-500 text-white font-black py-3 rounded-xl transition shadow-lg text-xs flex items-center justify-center gap-2 cursor-pointer transform hover:scale-[1.02]"
              >
                📁 Ver Carpetas de Periodo (T2 y T3) ↑
              </button>

              <div className="flex items-center justify-center gap-2 pt-1 text-center">
                <a
                  href={PERIOD_DRIVE_LINKS['T2']}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[11px] font-bold text-amber-300 hover:text-amber-200 bg-amber-950/60 border border-amber-500/40 px-2.5 py-1 rounded-lg transition"
                >
                  Abrir T2 ↗
                </a>
                <a
                  href={PERIOD_DRIVE_LINKS['T3']}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[11px] font-bold text-emerald-300 hover:text-emerald-200 bg-emerald-950/60 border border-emerald-500/40 px-2.5 py-1 rounded-lg transition"
                >
                  Abrir T3 ↗
                </a>
              </div>
            </div>
          </div>

          {/* GRADO 9° */}
          <div className="bg-slate-900/90 border border-slate-700/80 p-6 rounded-3xl shadow-xl flex flex-col justify-between hover:border-emerald-400 transition space-y-4">
            <div>
              <div className="flex justify-between items-center mb-2">
                <span className="bg-emerald-600/30 text-emerald-300 font-mono font-bold text-xs px-2.5 py-1 rounded-lg border border-emerald-400/40">
                  Grado 9°
                </span>
                <span className="text-2xl">📙</span>
              </div>
              <h4 className="text-lg font-extrabold text-white">Competencias Avanzadas</h4>
              <p className="text-xs text-slate-300 mt-2 leading-relaxed">
                Guías de voz pasiva, Used to, Present Perfect, condicionales y lecturas de preparación para pruebas ICFES Saber.
              </p>
            </div>

            <div className="pt-4 border-t border-slate-800 space-y-2.5">
              <button 
                onClick={scrollToPeriods}
                className="w-full bg-emerald-600 hover:bg-emerald-500 text-white font-black py-3 rounded-xl transition shadow-lg text-xs flex items-center justify-center gap-2 cursor-pointer transform hover:scale-[1.02]"
              >
                📁 Ver Carpetas de Periodo (T2 y T3) ↑
              </button>

              <div className="flex items-center justify-center gap-2 pt-1 text-center">
                <a
                  href={PERIOD_DRIVE_LINKS['T2']}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[11px] font-bold text-amber-300 hover:text-amber-200 bg-amber-950/60 border border-amber-500/40 px-2.5 py-1 rounded-lg transition"
                >
                  Abrir T2 ↗
                </a>
                <a
                  href={PERIOD_DRIVE_LINKS['T3']}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[11px] font-bold text-emerald-300 hover:text-emerald-200 bg-emerald-950/60 border border-emerald-500/40 px-2.5 py-1 rounded-lg transition"
                >
                  Abrir T3 ↗
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>

      {/* NOTA INFORMATIVA */}
      <div className="bg-slate-950/80 border border-slate-800 p-5 rounded-2xl text-xs text-slate-400 flex items-center gap-3">
        <span className="text-2xl">💡</span>
        <span>
          <strong>Información para Estudiantes y Familias:</strong> Las carpetas compartidas están configuradas con acceso público de lectura. Puedes descargar, guardar o imprimir cualquier taller pedagógico en formato PDF sin necesidad de iniciar sesión.
        </span>
      </div>

    </div>
  );
}
